import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";

import Tooltip from "../../shared/components/Tooltip";
import { allResourceTypeLabel } from "../../shared/utils";
import { resources } from "../actions";
import ResourcesListItem from "../components/ResourcesListItem";
import { ResourceShape, ResourceTypeShape } from "../proptypes";
import selectors from "../selectors";

class ResourcesListGroup extends Component {
  state = { allSelected: false };

  static getDerivedStateFromProps = props => {
    const { currentResource, resources } = props;
    const allResource = resources.find(resource => !resource.identifier);

    if (currentResource && allResource) {
      return { allSelected: allResource.$uri === currentResource.$uri };
    }
    return { allSelected: false };
  };

  generateHeading = () => {
    const { allSelected } = this.state;
    const { resources, resourceType, selectResource } = this.props;

    const allResource = resources.find(resource => !resource.identifier);

    if (allResource) {
      return (
        <div
          className={`p-button--list u-no-margin--right ${
            allSelected ? "is-selected is-emphasised" : ""
          }`}
          role="button"
          tabIndex={0}
          onClick={() => selectResource(allResource.$uri)}
          onKeyPress={() => selectResource(allResource.$uri)}
        >
          {allResourceTypeLabel(resourceType.name)}
          <Tooltip message={resourceType.summary}>
            <i className="p-icon--information p-icon__text" />
          </Tooltip>
        </div>
      );
    }
    return (
      <div style={{ padding: ".3125rem .5rem" }}>
        {resourceType.name}
        <Tooltip message={resourceType.summary}>
          <i className="p-icon--information p-icon__text" />
        </Tooltip>
      </div>
    );
  };

  generateResourceItems = () => {
    const { allSelected } = this.state;
    const { resources, currentResource, selectResource } = this.props;

    return resources.map(resource => {
      const selected =
        currentResource && resource.$uri === currentResource.$uri;

      if (resource.identifier) {
        return (
          <ResourcesListItem
            resource={resource}
            key={resource.$uri}
            onResourceClicked={() =>
              selectResource(resource.$uri, currentResource)
            }
            selected={selected || allSelected}
          />
        );
      }
      return undefined;
    });
  };

  render = () => (
    <li className="p-list__item">
      {this.generateHeading()}
      <div>
        <ul className="p-list u-no-margin--bottom">
          {this.generateResourceItems()}
        </ul>
      </div>
    </li>
  );
}

ResourcesListGroup.propTypes = {
  resourceType: ResourceTypeShape.isRequired,
  resources: PropTypes.arrayOf(ResourceShape).isRequired,
  currentResource: ResourceShape,
  selectResource: PropTypes.func.isRequired
};

ResourcesListGroup.defaultProps = {
  currentResource: undefined
};

const mapDispatchToProps = {
  selectResource: resources.setCurrent
};

const mapStateToProps = state => ({
  currentResource: selectors.resources.getCurrent(state)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ResourcesListGroup);
